export default {
  sm: `
  All robots of DATA CENTER GAK Sejong are connected by ARC's ultra-low-latency network. ARC, which stands for AI, Robot, and Cloud, is a multi-robot intelligence system based on cloud. The ARC monitors the location and status of all robots and autonomous shuttles in real time, and connects them to spatial infrastructure and services.

  Through unmanned, automated, and autonomous mobility systems based on robots, the safety and efficiency of GAK Sejong is maximized.
  `,
};
